import styled from "styled-components";
import BreakpointUp from "../Media/BreakpointUp";
import Pointer from "../../images/pointer.svg";

export const Section = styled.section`
  background-image: ${(props) => props.bgImg};
  background-color: ${(props) => props.bgColor};
  background-size: ${(props) => props.bgSize};
  height: ${(props) => props.ht};
  text-align: ${(props) => props.textAlign};
  position: relative;
  z-index: ${(props) => props.zIndex};
  padding-top: ${(props) => props.pt};
  padding-bottom: ${(props) => props.pb};
  overflow: ${(props) => props.overflow};
  &:before,
  &:after {
    content: "";
    position: absolute;
  }
  &:before {
    display: ${(props) => (props.bgBefore ? "block" : "none")};
    top: ${(props) => props.topBefore};
    right: ${(props) => props.rightBefore};
    bottom: ${(props) => props.bottomBefore};
    left: ${(props) => props.leftBefore};
    background: ${(props) => props.bgBefore};
    background-size: ${(props) => props.bgBeforeSize};
    background-repeat: ${(props) => props.bgBeforeRepeat};
    width: ${(props) => props.bgBeforeWidth};
    height: ${(props) => props.bgBeforeHeight};
    opacity: ${(props) => props.opacityBefore};
  }
  &:after {
    display: ${(props) => (props.bgAfter ? "block" : "none")};
    top: ${(props) => props.topAfter};
    right: ${(props) => props.rightAfter};
    bottom: ${(props) => props.bottomAfter};
    left: ${(props) => props.leftAfter};
    background: ${(props) => props.bgAfter};
    background-size: ${(props) => props.bgAfterSize};
    background-repeat: ${(props) => props.bgAfterRepeat};
    width: ${(props) => props.bgAfterWidth};
    height: ${(props) => props.bgAfterHeight};
    opacity: ${(props) => props.opacityAfter};
  }
  ${BreakpointUp.lg`
		padding-top: ${(props) => props.lpt};
		padding-bottom: ${(props) => props.lpb};
		margin-top: ${(props) => props.lmt};
	`}
  ${BreakpointUp.xl`
		padding-top: ${(props) => props.xpt};
		padding-bottom: ${(props) => props.xpb};
	`}
	${BreakpointUp.xxl`
		padding-top: ${(props) => props.ept};
		padding-bottom: ${(props) => props.epb};
	`}
`;

Section.defaultProps = {
  top: "0",
  bgImg: "inherit",
  bgColor: "white",
  bgSize: "inherit",
  textAlign: "left",
  topAfter: "0",
  topBefore: "0",
};

export const Container = styled.div`
  position: relative;
  z-index: ${(props) => props.zIndex};
  max-width: ${(props) => props.maxWidth};
  width: 100%;
  margin: 0 auto;
  padding: 0 16px;
  @media (min-width: 992px) {
    padding: 0 30px;
  }
`;

Container.defaultProps = {
  zIndex: "inherit",
  maxWidth: "1410px",
};
export const ContainerFluid = styled.div`
  position: relative;
  z-index: ${(props) => props.zIndex};
  max-width: ${(props) => props.maxWidth};
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  @media (min-width: 992px) {
    padding: 0 30px;
  }
`;

ContainerFluid.defaultProps = {
  zIndex: "inherit",
  maxWidth: "100%",
};

export const SectionImageBkg = styled.div`
  position: absolute;
  z-index: 0;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  right: ${(props) => props.right};
  opacity: ${(props) => props.opacity};
  background-color: ${(props) => props.bgColor};
  overflow: ${(props) => props.overflow};

  > .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    opacity: ${(props) => props.opacityImg};
  }
  &:after {
    content: "";
    display: ${(props) => (props.bgAfter ? "block" : "none")};
    position: absolute;
    top: ${(props) => props.topAfter};
    left: ${(props) => props.leftAfter};
    right: ${(props) => props.rightAfter};
    background-color: ${(props) => props.bgAfter};
    width: ${(props) => props.widthAfter};
    height: ${(props) => props.HeightAfter};
  }
`;
SectionImageBkg.defaultProps = {
  opacity: "inherit",
  height: "100%",
  width: "100%",
  top: "0",
  left: "0",
  right: "auto",

  topAfter: "0",
  leftAfter: "0",
  widthAfter: "100%",
  HeightAfter: "100%",
};

export const SectionPageTitle = styled.h1`
  max-width: ${(props) => props.maxWidth};
  color: ${(props) => props.color};
  text-align: ${(props) => props.textAlign};
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
  margin-left: ${(props) => props.ml};
  top: ${(props) => props.top};
  margin-right: auto;
  width: 100%;
  text-transform: ${(props) => props.textTransform};
  position: relative;
  z-index: 1;
`;

SectionPageTitle.defaultProps = {
  textAlign: "left",
  maxWidth: "100%",
  color: "#373636",
  mt: "0",
  ml: "auto",
  mb: "10px",
  top: "auto",
};

export const SectionTitle = styled.h2`
  max-width: ${(props) => props.maxWidth};
  color: ${(props) => props.color};
  text-align: ${(props) => props.textAlign};
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
  margin-left: ${(props) => props.ml};
  top: ${(props) => props.top};
  margin-right: auto;
  width: 100%;
  position: relative;
  z-index: 1;
  text-transform: ${(props) => props.textTransform};
  span {
    background-color: #373636;
    color: #fff;
    -webkit-background-clip: text;
    -webkit-text-stroke: 4px transparent;
    padding: 0 2px;
    letter-spacing: 1px;
    &.stroke-white {
      background-color: #fff;
      color: #373636;
    }
  }
`;

SectionTitle.defaultProps = {
  textAlign: "left",
  maxWidth: "100%",
  color: "#373636",
  mt: "auto",
  ml: "auto",
  mb: "10px",
  top: "auto",
};

export const SectionSubTitle = styled.strong`
  max-width: ${(props) => props.maxWidth};
  color: ${(props) => props.color};
  text-align: ${(props) => props.textAlign};
  margin-bottom: ${(props) => props.mb};
  width: 100%;
  text-transform: uppercase;
  position: relative;
  z-index: 1;
  span {
    background-color: #373636;
    color: #fff;
    -webkit-background-clip: text;
    -webkit-text-stroke: 4px transparent;
    padding: 0 2px;
    letter-spacing: 1px;

    &.stroke-white {
      background-color: #fff;
      color: #373636;
    }
  }
`;

SectionSubTitle.defaultProps = {
  textAlign: "left",
  maxWidth: "100%",
  color: "#373636",
  mb: "10px",
};

export const SectionLead = styled.div`
  margin-left: ${(props) => props.ml};
  margin-right: ${(props) => props.mr};
  margin-bottom: ${(props) => props.mb};
  text-align: ${(props) => props.textAlign};
  max-width: ${(props) => props.maxWidth};
  color: ${(props) => props.color};
  width: 100%;
  p {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 0;
    @media (min-width: 992px) {
      font-size: 20px;
      line-height: 34px;
    }
    @media (min-width: 1200px) {
      font-size: 22px;
      line-height: 36px;
    }
    ${BreakpointUp.xxl`
            font-size: 24px;
            line-height: 40px;
        `}

    + p {
      margin-top: 15px;
      @media (min-width: 1200px) {
        margin-top: 20px;
      }
      @media (min-width: 1600px) {
        margin-top: 30px;
      }
    }
  }
`;
SectionLead.defaultProps = {
  textAlign: "left",
  mb: "20px",
  ml: "auto",
  mr: "auto",
  maxWidth: "100%",
  color: "#161420",
};

export const SectionDescription = styled.div`
  position: relative;
  margin-left: ${(props) => props.ml};
  margin-right: ${(props) => props.mr};
  margin-bottom: ${(props) => props.mb};
  text-align: ${(props) => props.textAlign};
  max-width: ${(props) => props.maxWidth};
  color: ${(props) => props.color};
  font-style: ${(props) => props.fontStyle};
  font-weight: 500;
  width: 100%;
  z-index: ${(props) => props.zIndex};
  & p {
    margin-bottom: 0;
    & strong {
      font-weight: 700;
    }
    + p {
      margin-top: 15px;
      @media (min-width: 1200px) {
        margin-top: 20px;
      }
      @media (min-width: 1600px) {
        margin-top: 30px;
      }
    }
    & a {
      font-weight: 700;
      text-decoration: ${(props) => props.textDecoration};
      &:hover,
      &:focus {
        text-decoration: none;
      }
    }
  }
  & hr {
    background-color: ${(props) => props.hrcolor};
  }

  & ul,
  & ol {
    list-style: none;
    padding: 0;

    font-size: 18px;
    line-height: 30px;
    font-weight: 500;
    margin: 0 0 40px 0;
    @media (min-width: 768px) {
      margin: 0 0 40px 30px;
    }
    @media (min-width: 1200px) {
      font-size: 20px;
      line-height: 32px;
    }
    @media (min-width: 1600px) {
      font-size: 22px;
      line-height: 34px;
    }
    & li {
      padding-left: 40px;
      vertical-align: text-top;
      margin: 0;
      > strong {
        font-weight: 700;
      }
      + li {
        margin-top: 20px;
      }
      &:before {
        content: url(${Pointer});
        display: inline-block;
        vertical-align: text-top;
        margin-left: -40px;
        width: 40px;
      }
    }
    &.column-two {
      @media (min-width: 992px) {
        column-count: 2;
        column-gap: 30px;
      }
    }
  }
  table {
    border-collapse: collapse;
	}
	table {
		width: 100%;
		margin-bottom:15px;
		font-size: 16px;
    line-height: 28px;
		@media (min-width: 1200px) {
			font-size: 18px;
			line-height: 30px;
		}
	}
	table td, table th {
		padding: 5px;
		vertical-align: top;
		border: 1px solid #bdc1d9;
	}
	table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #bdc1d9;
		font-weight:700;
	}
`;
SectionDescription.defaultProps = {
  textAlign: "left",
  mb: "30px",
  ml: "auto",
  mr: "auto",
  maxWidth: "100%",
  color: "#373636",
  fontStyle: "inherit",
};
export const SectionLineDescription = styled(SectionDescription)`
  position: static;
  &:before {
    content: "";
    background-color: #576be4;
    position: absolute;
    top: 0;
    left: 0;
    height: 210px;
    width: 5px;
    @media (min-width: 992px) {
      width: 10px;
    }
    @media (min-width: 1600px) {
      width: 26px;
    }
  }
`;
SectionLineDescription.defaultProps = {};

export const ExploreMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${(props) => props.mt};
  margin-bottom: ${(props) => props.mb};
  justify-content: ${(props) => props.justifyContent};
  @media (max-width: 767.98px) {
    justify-content: ${(props) => props.justifyContentSm};
  }
  button {
    padding: 0;
  }
`;
ExploreMore.defaultProps = {
  mt: "0px",
  mb: "0px",
  justifyContent: "center",
};

export const BreadCrumb = styled.div`
  position: relative;
  z-index: 2;
  top: 0;
  left: ${(props) => props.left};
  text-align: ${(props) => props.textAlign};
  /* font-weight: 600; */
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 10px;
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }
  ${BreakpointUp.xl`
		font-size: 14px;
		line-height: 24px;	
	`}
  & a, & span {
    position: relative;
    display: inline-block;
    vertical-align: middle;
  }
  & a {
    padding-right: 12px;
  }
  & a {
    color: #fff;
    &:hover,
    &:focus {
      color: #ff4848;
    }
    + a,
    + span {
      padding: 0 12px;
      &:before {
        color: #fff;
        content: "/";
        position: absolute;
        top: 50%;
        left: -3px;
        transform: translateY(-50%);
      }
    }
  }
  & span {
    color: #fff;
    letter-spacing: 0.5px;
    + span {
      padding: 0 12px;
      &:before {
        color: #fff;
        content: "/";
        position: absolute;
        top: 50%;
        left: -3px;
        transform: translateY(-50%);
      }
    }
    &:last-child {
      color: #ff4848;
      /* font-weight: 700; */
    }
  }
  &.black {
    & a {
      color: #161420;
      &:hover,
      &:focus {
        color: #ff4848;
      }
      + a,
      + span {
        &:before {
          color: #161420;
        }
      }
    }
    & span {
      color: #161420;
      + span {
        &:before {
          color: #161420;
        }
      }
      &:last-child {
        color: #ff4848;
      }
    }
  }
  &.white {
    & a {
      color: #161420;
      &:hover,
      &:focus {
        color: #ff4848;
      }
      + a,
      + span {
        &:before {
          color: #161420;
        }
      }
    }
    & span {
      color: #161420;
      + span {
        &:before {
          color: #161420;
        }
      }
      &:last-child {
        color: #fff;
      }
    }
  }
`;
BreadCrumb.defaultProps = {
  left: "0px",
  textAlign: "left",
};

export const MarkdownContent = styled.div`
  display: ${(props) => props.display};
  max-width: ${(props) => props.maxWidth};
  width: 100%;
  margin: 0 auto;
  padding-left: ${(props) => props.pl};
  padding-right: ${(props) => props.pr};
  text-align: ${(props) => props.textAlign};
  color: ${(props) => props.color};

  & p {
    text-align: ${(props) => props.textAlign};
    color: ${(props) => props.color};
    margin-bottom: 20px;

    font-size: 16px;
    line-height: 28px;
    @media (min-width: 1200px) {
      font-size: 18px;
      line-height: 34px;
    }
    
  }
  a {
    font-weight: 700;
    position: relative;
    &:after {
      content: "";
      bottom: 0;
      display: block;
      height: 2px;
      left: 50%;
      position: absolute;
      background: #c20000;
      transition: width 0.3s ease 0s, left 0.3s ease 0s;
      width: 0px;
      transform: translateX(-50%);
    }
    &:hover {
      &:after {
        width: 100%;
      }
    }
  }
  & h2:first-child {
    padding-top: 0;
  }
  & h1 {
    font-size: 24px;
    line-height: 34px;
    @media (min-width: 768px) {
      font-size: 30px;
      line-height: 40px;
    }
    @media (min-width: 992px) {
      font-size: 36px;
      line-height: 46px;
    }
    @media (min-width: 1200px) {
      font-size: 42px;
      line-height: 52px;
    }
    @media (min-width: 1600px) {
      font-size: 48px;
      line-height: 58px;
    }
  }
  & h2 {
    font-size: 20px;
    line-height: 30px;
    @media (min-width: 992px) {
      font-size: 24px;
      line-height: 34px;
    }
    @media (min-width: 1200px) {
      font-size: 30px;
      line-height: 40px;
    }
    @media (min-width: 1600px) {
      font-size: 32px;
      line-height: 42px;
    }
  }
  & h3 {
    font-size: 16px;
    line-height: 30px;
    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 30px;
    }
    @media (min-width: 992px) {
      font-size: 20px;
      line-height: 30px;
    }
    @media (min-width: 1200px) {
      font-size: 24px;
      line-height: 34px;
    }
    @media (min-width: 1600px) {
      font-size: 28px;
      line-height: 38px;
    }
  }
  & h2,
  & h3,
  & h4 {
    padding-top: 15px;
    @media (min-width: 1200px) {
      padding-top: 20px;
    }
    @media (min-width: 1600px) {
      padding-top: 30px;
    }
  }
  & ul,
  & ol {
    list-style: none;
    margin: 0 0 40px;
    padding: 0;

    font-size: 16px;
    line-height: 28px;
    @media (min-width: 1200px) {
      font-size: 18px;
      line-height: 30px;
    }
    & li {
      padding-left: 40px;
      vertical-align: text-top;
      margin: 0;
      > strong {
        font-weight: 700;
      }
      + li {
        margin-top: 20px;
      }
      &:before {
        content: url(${Pointer});
        display: inline-block;
        vertical-align: text-top;
        margin-left: -40px;
        width: 40px;
      }
    }
  }
  table {
    border-collapse: collapse;
	}
	table {
		width: 100%;
		margin-bottom:15px;
		font-size: 16px;
    line-height: 28px;
		@media (min-width: 1200px) {
			font-size: 18px;
			line-height: 30px;
		}
	}
	table td, table th {
		padding: 5px;
		vertical-align: top;
		border: 1px solid #bdc1d9;
	}
	table thead th {
		vertical-align: bottom;
		border-bottom: 2px solid #bdc1d9;
		font-weight:700;
	}
`;

MarkdownContent.defaultProps = {
  textAlign: "left",
  maxWidth: "none",
  pl: "0",
  pr: "0",
  display: "block",
};

export const BaseButton = styled.span`
  position: relative;
  display: inline-flex;
  justify-content: center;
  text-align: center;
  font-weight: 600;
  transition: all 500ms;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 10px;
  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &:before {
    transition: transform 0.3s cubic-bezier(0.7, 0, 0.2, 1);
  }
  &:hover {
    &:before {
      transform: translate3d(0, -100%, 0);
    }
  }
  > .text {
    display: inline-flex;
    align-items: center;
    position: relative;

    padding: 6px 20px;
    font-size: 16px;
    line-height: 30px;
    @media (min-width: 1200px) {
      padding: 8px 25px;
      font-size: 20px;
      line-height: 30px;
    }
    @media (min-width: 1600px) {
      padding: 12px 30px;
      font-size: 24px;
      line-height: 34px;
    }
    + .icon {
      padding-left: 0;
    }
  }
  > .icon {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 20px;
    @media (min-width: 1200px) {
      padding: 8px 25px;
    }
    @media (min-width: 1600px) {
      padding: 12px 30px;
    }
    &:empty {
      display: none;
    }
    + .text {
      padding-left: 0;
    }
  }
`;
export const ListPointer = styled.ul`
  list-style: none;
  padding: 0;

  font-size: 18px;
  line-height: 36px;
  font-weight: 500;
  margin: 0 0 40px 0;
  @media (min-width: 768px) {
    margin: 0 0 40px 30px;
  }
  @media (min-width: 1200px) {
    font-size: 20px;
    line-height: 40px;
  }
  @media (min-width: 1600px) {
    font-size: 22px;
    line-height: 42px;
  }
`;
ListPointer.defaultProps = {};

export const ListItemPointer = styled.li`
  padding-left: 40px;
  vertical-align: text-top;
  margin: 0;
  > strong {
    font-weight: 700;
  }
  + li {
    margin-top: 20px;
  }
  &:before {
    content: url(${Pointer});
    display: inline-block;
    margin-left: -40px;
    width: 40px;
  }
`;

export const MainPanel = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  @media (min-width: 1200px) {
    margin: 0 -15px;
  }
`;
export const LeftPanel = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 992px) {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
    padding: 0 15px;
  }
`;
export const RightPanel = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 992px) {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  @media (min-width: 1200px) {
    flex: 0 0 75%;
    max-width: 75%;
    padding: 0 15px;
  }
`;

export const DropSearch = styled.div`
  position: absolute;
  background-color: #fff;
  box-shadow: 0px 2px 25px rgba(0, 0, 0, 0.3);
  max-width: calc(100vw - 60px);
  top: 100%;
  left: 0;
  right: 0;
  z-index: 2;
  text-align: left;
  overflow-y: auto;
  max-height: 310px;
  border-radius: 8px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: #ebebeb;
  }
  &::-webkit-scrollbar-thumb {
    background: #6d6d6d;
    border-radius: 4px;
  }
`;
export const DropSearchBody = styled.div``;

export const DropSearchItem = styled.div`
  cursor: pointer;
  padding: 4px 20px;
  border-bottom: 1px solid rgb(227, 233, 242);
  &:last-child {
    border-bottom: none;
  }
  font-size: 12px;
  & a {
    display: flex;
    align-items: center;
    color: #444;
    font-weight: 500;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
    line-height: 22px;

    & svg {
      fill: #444;
      transition: transform 0.3s ease-out;
      width: 12px;
      display: none;
      ${BreakpointUp.xl`
				display:block;
			`}
    }
    &:hover {
      color: #000;
      svg {
        transform: translateX(4px);
        fill: #000;
      }
    }
  }
  &:hover {
    background: lightgray;
  }
`;

export const FaqGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 -15px;
  @media (min-width: 1200px) {
    margin: 0 -40px;
  }
  @media (min-width: 1600px) {
    margin: 0 -50px;
  }
`;
export const FaqLeftGrid = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  @media (min-width: 1200px) {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
    padding: 0 40px;
  }
  @media (min-width: 1600px) {
    padding: 0 50px;
  }
`;
export const FaqRightGrid = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  display: none;
  @media (min-width: 1200px) {
    display: flex;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
    padding: 0 40px;
  }
  @media (min-width: 1600px) {
    padding: 0 50px;
  }
`;